export default "__VITE_ASSET__Cdl_BojM__"